<template>
  <div class="menu menu-pc">
    <div class="logo-box">
      <router-link to="/"><img src="@/assets/img/Logo-AFCwave.png" /></router-link>
    </div>

    <ul class="menu-list">
        <li v-for="(item, index) in getMenuList" :key="index">
          <router-link :to="item.link" :class="{active: currLink == index}">{{item.name}}</router-link>
        </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'MenuPC',
  data() {
    return {
      currLink: 6,
    };
  },
  computed: {
    getMenuList: function (){
      return this.menulist.reverse();
    },
    menulist(){
      return [{
        name: this.$i18n.t('Layout.Menu.HomePage'),
        link: '/'
      },{
        name: this.$i18n.t('Layout.Menu.Products'),
        link: '/products'
      },{
        name: this.$i18n.t('Layout.Menu.Solutions'),
        link: '/solutions'
      }/*,{
        name: 'WIFI设计',
        link: '/wifi'
      }*/,{
        name: this.$i18n.t('Layout.Menu.Training'),
        link: '/training'
      },{
        name: this.$i18n.t('Layout.Menu.Resources'),
        link: '/resources'
      },{
        name: this.$i18n.t('Layout.Menu.AboutUs'),
        link: '/aboutus'
      },{
        name: this.$i18n.t('Layout.Menu.Contact'),
        link: '/contact'
      }];
    }
  },
  components: {
    
  },
  watch: {
    '$route'(v1, v2){
      this.currLink = this.getCurrLink();
    }
  },
  methods: {
    getCurrLink(){
      let currMenu = localStorage.getItem('currMenu');
      if(currMenu != null){
        return parseInt(currMenu);
      }
      return 0;
    }
  },
  created(){
    this.currLink = this.getCurrLink();
  }
};
</script>

<style lang="" scoped>
.menu{
  position: fixed;
  top: 40px;
  left: 0;
  width: 100%;
  height: 80px;
  background-color: #FFF;
  z-index: 1000;
  border-bottom: 2px solid #edeeee;
}

.menu-pc{
  display: block;
}

.logo-box{
  display: inline-block;
  height: 80px;
  width: 300px;
  float: left;
  position: relative;
}

.logo-box img{
  display: block;
  max-height: 80%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.menu-list{
  display: inline-block;
  width: calc(100% - 350px);
  margin-left: 18px;
  height: 80px;
  list-style: none;
}

.menu-list li{
  display: inline-block;
  height: 80px;
  padding: 0 15px;
  float: right;
}

.menu-list li a{
  display: inline-block;
  height: 30px;
  line-height: 30px;
  margin: 25px 0;
  font-size: 16px;
  font-weight: 500;
  color: #797979;
  text-decoration: none;
}

.menu-list li .active{
  color: #0B3777;
}

.menu-list li a:hover{
  color: #0B3777;
}

@media screen and (max-width: 920px){
  .menu-pc{
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Layout/MenuPC.vue